import { TApplicationState } from 'shared/types/redux';

export function favoriteSelector(state: TApplicationState) {
  return state.newbuilding.isFavorite;
}
